import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";

import {
    Label,
    SelectboxItems,
    SelectboxItem,
    SelectboxMenu,
    SelectboxLabel
} from "./style";

const Selectbox = ({settingsInfo, selectedList, itemValue, onSelected, name}) => {

    const [openSelectbox, setOpenSelectbox] = useState(false);
    const [selectedOption, setSelectedOption] = useState([]);
    const [data, setData] = useState([]);

    const handleSelectbox = () => {
        setOpenSelectbox(!openSelectbox);
    };

    const selectedItem = (item) => {
        setSelectedOption(item.value);
        onSelected({name: name, value: item.value});
        setOpenSelectbox(false);
    };

    useEffect(() => {
        setData(settingsInfo);
        setSelectedOption(selectedList);
    }, [settingsInfo, selectedList]);

    return (
        <SelectboxMenu onClick={handleSelectbox}>
            <Label>{selectedOption} {itemValue}</Label>
            {openSelectbox &&
                <SelectboxItems>
                    {data && data.map(item => (
                        <SelectboxItem
                            key={item.id}
                            onClick={() => selectedItem(item)}>
                            <SelectboxLabel>
                                {item.value} {itemValue}
                            </SelectboxLabel>
                        </SelectboxItem>
                    ))}
                </SelectboxItems>
            }
        </SelectboxMenu>
    );
};

Selectbox.propTypes = {
    settingsInfo: PropTypes.array.isRequired,
    selectedList: PropTypes.any,
    itemValue: PropTypes.string.isRequired,
    onSelected: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired
};

export default Selectbox;